<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Safety Observation</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #f="ngForm" (ngSubmit)="onSaveSafetyObservation(f, false)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <div class="row">
      <div class="col-12 col-lg-4">
        <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Category:</mat-label>
          <mat-select [(ngModel)]="safety_observation.so_category" required name="so_category" aria-label="Select the category of the safety observation.">
            <mat-option *ngFor="let so_category of utils.getSafetyObservationCategories()" [value]="so_category">{{ so_category }}</mat-option>
          </mat-select>
          <mat-hint>Select the category of the safety observation.</mat-hint>
        </mat-form-field>
      </div>

      <div class="col-12 col-lg-4">
        <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Type:</mat-label>
          <mat-select [(ngModel)]="safety_observation.so_type" required name="so_type" aria-label="Select the type of safety observation.">
            <mat-option *ngFor="let so_type of utils.getSafetyObservationTypes()" [value]="so_type">{{ so_type }}</mat-option>
          </mat-select>
          <mat-hint>Select the type of the safety observation.</mat-hint>
        </mat-form-field>
      </div>

      <div class="col-12 col-lg-4">
        <app-datetime-picker
          [selectedDateTime]="reportedDateTime"
          [isRequired]="true"
          [pickerName]="'reportedDateTime'"
          [label]="'When was this reported?'"
          [hint]="'Use the calendar icon to select the safety observation reported date and time.'"
          [selectTooltip]="'Select the safety observation reported date and time.'"
          [removeTooltip]="'Clear the safety observation reported date and time.'"
          [errorText]="'Please select a safety observation reported date and time.'"
          [classes]="'full-width mb-3'"
          (pickerDetailsOutput)="getOutputDateTimeDetails($event)"></app-datetime-picker>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 col-lg-4">
        <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Priority:</mat-label>
          <mat-select [(ngModel)]="safety_observation.so_priority" name="so_priority" aria-label="Select the priority of the safety observation.">
            <mat-option *ngFor="let so_priority of utils.getSafetyObservationPriorities()" [value]="so_priority">{{ so_priority }}</mat-option>
          </mat-select>
          <mat-hint>Select the priority of the safety observation.</mat-hint>
        </mat-form-field>
      </div>

      <div class="col-12 col-lg-4">
        <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Status:</mat-label>
          <mat-select [(ngModel)]="safety_observation.so_status" name="so_status" aria-label="Select the status of the safety observation.">
            <mat-option *ngFor="let so_status of utils.getSafetyObservationStatuses()" [value]="so_status">{{ so_status }}</mat-option>
          </mat-select>
          <mat-hint>Select the status of the safety observation.</mat-hint>
        </mat-form-field>
      </div>

      <div class="col-12 col-lg-4">
        <div class="d-flex align-items-center w-100 my-auto">
          <span class="material-icons mr-2">sentiment_very_dissatisfied</span>
          <mat-slider
            class="rating-slider-width"
            [max]="5"
            [min]="1"
            [step]="1"
            name="so_rating"
            [(ngModel)]="safety_observation.so_rating"
            showTickMarks
            discrete
            [displayWith]="formatRating">
            <input matSliderThumb />
          </mat-slider>
          <span class="material-icons ml-2">sentiment_satisfied_alt</span>
        </div>
        <mat-hint class="px-3 py-2">Use the slider above to rate the safety observation from 1-5.</mat-hint>
      </div>
    </div>

    <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Description of Safety Observation</mat-label>
      <textarea
        matInput
        rows="5"
        placeholder="Description"
        [(ngModel)]="safety_observation.so_description"
        name="so_description"
        id="so_description"
        required>
      </textarea>
      <mat-hint>Enter the description of the safety observation.</mat-hint>
    </mat-form-field>

    <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Action Taken</mat-label>
      <input
        matInput
        placeholder="Action Taken"
        [(ngModel)]="safety_observation.so_action_taken"
        name="so_action_taken"
        type="text"
        id="so_action_taken" />
      <mat-hint>Enter the action taken for the safety observation.</mat-hint>
    </mat-form-field>

    <div class="w-100">
      <div class="alert alert-warning mb-0" role="alert" *ngIf="!safety_observation.site_id || !f.valid">
        Please select a {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site').toLowerCase() }} to associate this safety observation with and complete the form above.
      </div>
    </div>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="p-3">

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="site_selector_button"
      (click)="onSelectSite()"
      [matBadge]="safety_observation.site_id ? '1' : '0'"
      matTooltip="Select the {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site').toLowerCase() }} you want the safety observation to be associated with.">
      <mat-icon>location_on</mat-icon>
      Select {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}
    </button>

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="contractor_selector_button"
      (click)="onSelectContractors()"
      [matBadge]="'' + (safety_observation.contractor_ids.length || safety_observation.contractors.length)"
      matTooltip="Select the {{ utils.getLangTerm('contractors.plural', 'Contractors') }} you want the safety observation to be associated with.">
      <fa-icon [icon]="faHardHat"></fa-icon>
      Select {{ utils.getLangTerm('contractors.plural', 'Contractors') }}
    </button>

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="users_selector_button"
      (click)="onSelectUsers()"
      [matBadge]="'' + (safety_observation.user_ids.length || safety_observation.users.length)"
      matTooltip="Select the users you want the safety observation associated with.">
      <mat-icon>account_circle</mat-icon>
      Select Users
    </button>

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="assets_selector_button"
      *ngIf="safety_observation.site_id && safety_observation.site_id > 0"
      (click)="onSelectAssets()"
      [matBadge]="'' + (safety_observation.asset_ids.length || safety_observation.assets.length)"
      matTooltip="Select the assets you want the safety observation associated with.">
      <mat-icon>forklift</mat-icon>
      Select Assets
    </button>

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      (click)="onSelectReporter()"
      [matBadge]="'' + (safety_observation.reported_by ? 1 : 0)"
      matTooltip="You can optionally select a reporter.">
      <mat-icon>rate_review</mat-icon>
      {{ !safety_observation.reported_by ? 'Select' : 'Change' }} Reporter
    </button>

    <div class="w-100"></div>

    <button
      mat-raised-button
      [disabled]="!f.valid || !safety_observation.site_id"
      class="my-2 ml-1 mr-2"
      type="button"
      color="primary"
      id="save_close_button"
      (click)="onSaveSafetyObservation(f, true)">
      <mat-icon>save</mat-icon>
      Save & Close
    </button>

    <button
      mat-raised-button
      [disabled]="!f.valid || !safety_observation.site_id"
      class="my-2 ml-1 mr-2"
      type="button"
      color="primary"
      id="save_continue_button"
      (click)="onSaveSafetyObservation(f, true,true)"
      *ngIf="canEdit">
      <mat-icon>save</mat-icon>
      Save & Continue
    </button>

    <app-file-browse-button
      (selectedFiles)="onSelectFiles($event)"
      (afterDialogClosedEvent)="onSaveSafetyObservation(f)"
      parentObjectType="safety_observation"
      [parentObjectId]="safety_observation.id"
      [filesCount]="safety_observation.files.length">
    </app-file-browse-button>

  </mat-dialog-actions>

</form>
